/**
 * Mã màn hình
 */
export default {
  Login: 'login',
  //#region Dự toán ngân sách
  BUPlanReceipt: 'BUPlanReceipt',
  BUPlanReceiptAddMLNS: 'BUPlanReceiptAddMLNS',
  BUPlanReceiptAddTT342: 'BUPlanReceiptAddTT342',
  BUPlanReceiptAddTT343: 'BUPlanReceiptAddTT343',
  BUPlanReceiptAddTT344: 'BUPlanReceiptAddTT344',
  BUPlanReceiptAdjustMLNS: 'BUPlanReceiptAdjustMLNS',
  BUPlanReceiptAdjustTT342: 'BUPlanReceiptAdjustTT342',
  BUPlanReceiptAdjustTT343: 'BUPlanReceiptAdjustTT343',
  BUPlanReceiptAdjustTT344: 'BUPlanReceiptAdjustTT344',
  BUPlanExpenseByBudget: 'BUPlanExpenseByBudget',
  BUPlanExpenseByActivity342: 'BUPlanExpenseByActivity342',
  BUPlanExpenseByActivity343: 'BUPlanExpenseByActivity343',
  BUPlanExpenseByActivity344: 'BUPlanExpenseByActivity344',
  BUPlanExpenseByActivityVt: 'BUPlanExpenseByActivityVt',
  BUPlanExpenseByBudgetSupplementAdjust: 'BUPlanExpenseByBudgetSupplementAdjust',
  BUPlanExpenseByActivitySupplementAdjust342: 'BUPlanExpenseByActivitySupplementAdjust342',
  BUPlanExpenseByActivitySupplementAdjust343: 'BUPlanExpenseByActivitySupplementAdjust343',
  BUPlanExpenseByActivitySupplementAdjust344: 'BUPlanExpenseByActivitySupplementAdjust344',
  BUPlanExpenseByActivitySupplementAdjustVt: 'BUPlanExpenseByActivitySupplementAdjustVt',
  BUPlanAdjustmentDetail: 'BUPlanAdjustmentDetail',
  BUTreasuryWithdrawal: 'BUTreasuryWithdrawal', // Phiếu rút tiền kho bạc
  BUBasicConstructionInvestment: 'BUBasicConstructionInvestment', // Kế hoạch vốn đầu tư xây dựng cơ bản
  BUTransferDeposit: 'BUTransferDeposit',
  BUPlanSummaryReceiptMLNS: 'BUPlanSummaryReceiptMLNS',
  BUPlanSummaryReceiptTT342: 'BUPlanSummaryReceiptTT342',
  BUPlanSummaryReceiptTT343: 'BUPlanSummaryReceiptTT343',
  BUPlanSummaryReceiptTT344: 'BUPlanSummaryReceiptTT344',
  BUPlanSummaryExpenseMLNS: 'BUPlanSummaryExpenseMLNS',
  BUPlanSummaryExpenseTT342: 'BUPlanSummaryExpenseTT342',
  BUPlanSummaryExpenseTT343: 'BUPlanSummaryExpenseTT343',
  BUPlanSummaryExpenseTT344: 'BUPlanSummaryExpenseTT344',
  BUPlanSummaryExpenseTT344Vt: 'BUPlanSummaryExpenseTT344Vt',
  //#endregion

  //#region Tổng quan
  Dashboard: 'Dashboard',
  //#endregion

  //#region Tiền mặt
  CAPaymentDetail: 'CAPaymentDetail',
  CAHandleDiffMoney: 'CAHandleDiffMoney',
  //#endregion

  //#region Vật tư, Công cụ dụng cụ
  ToolIncrementDetail: 'ToolIncrementDetail',
  ToolDecrementDetail: 'ToolDecrementDetail',
  //#endregion

  //#region
  SaPayment: 'SaPayment', // Chứng từ trả lương, bảo hiểm (author nvthinh 25.1.2024)
  //#endregion

  //#region Tổng hợp
  SUCreateReportDetail: 'SUCreateReportDetail',
  //#endregion

  //#region Danh sách
  ToolIncrement: 'ToolIncrement',
  ToolDecrement: 'ToolDecrement',
  FAVoucherQLTSList: 'FAVoucherQLTSList',
  //#endregion

  //#region Danh mục
  DefaultAccount: 'DefaultAccount',
  BudgetItemDetail: 'BudgetItemDetail',
  FixedAssetCategory: 'FixedAssetCategory',
  //#endregion

  //#region Hệ thống
  //#region Nhập số dư ban đầu
  AccountBalance: 'AccountBalance',
  BankAccountBalance: 'BankAccountBalance',
  AccountingObjectBalance: 'AccountingObjectBalance',
  InventoryMaterial: 'InventoryMaterial',
  OtherAccountBalance: 'OtherAccountBalance',
  //#endregion

  //#region Hệ thống
  ReSortRefNo: 'ReSortRefNo',
  ResultConvert: 'ResultConvert',
  //#endregion

  //#region Thông tin chung
  QuickReport: 'QuickReport',
  //#endregion

  //#endregion

  BUTransfer: 'BUTransfer',
  AccountingObject: 'AccountingObject',
  AccountingObjectList: 'AccountingObjectList',
  DIStatistic: 'DIStatistic',
  DIStock: 'DIStock',
  BUFinancialActivities: 'BUFinancialActivities',
  BUInvestmentPlanXDCB: 'BUInvestmentPlanXDCB',
  BUPlanSummary: 'BUPlanSummary',
  BUPlanTemplateExpense: 'BUPlanTemplateExpense',
  BUPlanTemplateReceipt: 'BUPlanTemplateReceipt',
  BADepositDetail: 'BADepositDetail',
  BADeposit: 'BADeposit',
  BAInternalTransfer: 'BAInternalTransfer',
  BAAdvanceNSNN: 'BAAdvanceNSNN',
  BAWithDraw: 'BAWithDraw',
  DIActivity: 'DIActivity',
  DIActivityCategory: 'DIActivityCategory',
  DIBranch: 'DIBranch',
  DIDepartment: 'DIDepartment',
  DIProject: 'DIProject',
  FixedAssetList: 'FixedAssetList',
  DIFund: 'DIFund',
  DIFundStructure: 'DIFundStructure',
  DIContract: 'DIContract',
  DIHamlet: 'DIHamlet',
  DISalaryScale: 'DISalaryScale',
  DIEquipmentInventoryItem: 'DIEquipmentInventoryItem',
  DIInventoryCategory: 'DIInventoryCategory',
  DIBankInfo: 'DIBankInfo',
  DIBankInfoCategory: 'DIBankInfoCategory',
  CAAdjustReceipt: 'CAAdjustReceipt',
  CAAdjustPayment: 'CAAdjustPayment',
  CACash: 'CACash',
  CAPayment: 'CAPayment',
  CAReceipt: 'CAReceipt',
  CAPaymentSalary: 'CAPaymentSalary',
  CAReceiptWithdraw: 'CAReceiptWithdraw',
  CAFundInventory: 'CAFundInventory',
  BUPlanAdjustment: 'BUPlanAdjustment',
  BUPlanWdAdjustment: 'BUPlanWdAdjustment',
  BUEnterCashFund: 'BUEnterCashFund',
  BUCreateDeclareTable: 'BUCreateDeclareTable',
  BUAdjustment: 'BUAdjustment',
  BUPlanAdjustCommit: 'BUPlanAdjustCommit',
  BUPlanCancel: 'BUPlanCancel',
  BUPlanCommitExpense: 'BUPlanCommitExpense',
  BUPlanExpense: 'BUPlanExpense',
  BUBudgetReserve: 'BUBudgetReserve',
  BUTransfer: 'BUTransfer',
  BUReceiveBudgetPlan: 'BUReceiveBudgetPlan',
  BUPlanReceiveAnnual: 'BUPlanReceiveAnnual',
  BUPlanReceiveSuppler: 'BUPlanReceiveSuppler',
  BUPlanReceiveAdjust: 'BUPlanReceiveAdjust',
  DIBudgetGroupItem: 'DIBudgetGroupItem',
  DIBudgetProvide: 'DIBudgetProvide',
  DIBudgetSourceProperty: 'DIBudgetSourceProperty',
  FAVoucherQLTS: 'FAVoucherQLTS',
  FAVoucherAdjustment: 'FAVoucherAdjustment',
  FAVoucherDecrement: 'FAVoucherDecrement',
  FAVoucherDepreciation: 'FAVoucherDepreciation',
  FAVoucherIncreament: 'FAVoucherIncreament',
  SUGeneralVoucher: 'SUGeneralVoucher',
  SUGeneralParallel: 'SUGeneralParallel',
  SUTransfer: 'SUTransfer',
  DILocalBudgetItem: 'DILocalBudgetItem',
  DIInventoryItem: 'DIInventoryItem',
  EReceipt: 'EReceipt',
  EReceiptDetail: 'EReceiptDetail',
  EReceiptVoucherDetail: 'EReceiptVoucherDetail',
  EReceiptSummary: 'EReceiptSummary',
  EReceiptSummaryDetail: 'EReceiptSummaryDetail',
  DIAccessHistory: 'DIAccessHistory',
  INTransfer: 'INTransfer',
  UserManagement: 'UserManagement',
  AdvancedSercurity: 'AdvancedSercurity',
  SURegisterList: 'SURegisterList',
  SUVoucherList: 'SUVoucherList',
  SUSubmitReport: 'SUSubmitReport', // Nộp báo cáo cấp trên
  RoleManagement: 'RoleManagement',
  SUCreateReport: 'SUCreateReport',
  SULockLedger: 'SULockLedger',
  RegimePosted: 'RegimePosted',
  DefaultImplicitSetting: 'DefaultImplicitSetting',
  OPAccountBalance: 'OPAccountBalance',
  SUAccountTransfer: 'SUAccountTransfer',
  GetOPAccountBalance: 'GetOPAccountBalance',
  SUAccountTransferDetail: 'SUAccountTransferDetail',
  ReportUpdateHistory: 'ReportUpdateHistory',
  BUPlanActivityTempSymmet: 'BUPlanActivityTempSymmet',
  BUPlanTempReceiptReport: 'BUPlanTempReceiptReport',
  BUPlanTempExpenseReport: 'BUPlanTempExpenseReport',
  DISystemAccounts: 'DISystemAccounts',
  DIAccountTransfer: 'DIAccountTransfer',
  DIAutoBusiness: 'DIAutoBusiness',
  DIAccountParallelRule: 'DIAccountParallelRule',
  DIBudgetChapter: 'DIBudgetChapter',
  DIBudgetKindItem: 'DIBudgetKindItem',
  DIBudgetItemSpend: 'DIBudgetItemSpend',
  DIBudgetItemCollect: 'DIBudgetItemCollect',
  DIBudgetSource: 'DIBudgetSource',
  SettingInitialInformationDeclaration: 'SettingInitialInformationDeclaration',
  SettingBusiness: 'SettingBusiness',
  SettingFormatNumber: 'SettingFormatNumber',
  PrintReportSetting: 'PrintReportSetting',
  ConnectMisaApp: 'ConnectMisaApp',
  CompanyInfo: 'CompanyInfo',
  INInward: 'INInward',
  INInwardOther: 'INInwardOther',
  InventoryInwardCash: 'InventoryInwardCash',
  InventoryInwardDeposit: 'InventoryInwardDeposit',
  BUReceiptExpense: 'BUReceiptExpense',
  CheckFormular: 'CheckFormular',

  // Danh mục
  DIAccountingObjectCategory: 'DIAccountingObjectCategory', // Loại đối tượng
  DIEquipmentInventoryItem: 'DIEquipmentInventoryItem', // Công cụ dụng cụ
  InOutWard: 'InOutWard',
  SUDecrementDetail: 'SUDecrementDetail',
  BUAdvancePaymentDetail: 'BUAdvancePaymentDetail',
  BUAdvanceExpenceDetail: 'BUAdvanceExpenceDetail',
  DataManagement: 'DataManagement',
  BackupRestoreData: 'BackupRestoreData',
  Report: 'Report',
  SummaryProcess: 'SummaryProcess',
  SalaryProcess: 'SalaryProcess',
  FAVoucherProcees: 'FAVoucherProcees',
  ToolsProcess: 'ToolsProcess',
  ReceipProcess: 'ReceipProcess',
  DepositsProcess: 'DepositsProcess',
  CashProcess: 'CashProcess',
  PlanReceiptProcess: 'PlanReceiptProcess',
  EtreasuryProcess: 'EtreasuryProcess',
  Dictionary: 'Dictionary',
  SaAccounting: 'SaAccounting',
  VoucherSearch: 'VoucherSearch',

  DvcUser: 'DvcUser',
  DvcFileList: 'DvcFileList',

  SettingFinancialReport: 'SettingFinancialReport',
  TreasuryCash: 'TreasuryCash',
  TreasuryTransfer: 'TreasuryTransfer',
  TreasuryToAccountCash: 'TreasuryToAccountCash',
  TreasuryDepositsToCash: 'TreasuryDepositsToCash',
  SpendTransfer: 'SpendTransfer',
  AdvancePayment: 'AdvancePayment',
  DvcInvestmentAdvance: 'DvcInvestmentAdvance',
  Adjustment: 'Adjustment',
  InvestmentWithTransfer: 'InvestmentWithTransfer',
  InvestmentWithCash: 'InvestmentWithCash',
  InvestmentAdvance: 'InvestmentAdvance',
  CustomDetailTemplate: 'CustomDetailTemplate',
  QuickReport: 'QuickReport',

  // Hoá đơn mua hàng inbot
  InbotInvoice: 'InbotInvoice',
  DvcBudget: 'DvcBudget',
  DcsdFileList: 'DcsdFileList',

  // kết quả kiểm tra
  ExaminationResultTabs: 'ExaminationResultTabs',
  SettlementInstructions: 'SettlementInstructions',
};
